
import { date, showAlert } from '../../lib/helpers';
import { headers, search, searchFields, dataMaxSelectedChangePic, dataDelayServiceHit} from './attributes';

export default {
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialogLoader: false,
    dialogSwitch: false,
    dialogPIC: false,
    headers,
    editedIndex: -1,
    search,
    searchPIC: '',
    searchModalApproverOne: '',
    searchModalApproverTwo: '',
    selectedRow: '',
    dateFormatted: '',
    dateMenu: false,
    searchActiveUser: '',
    searchApproverOne: '',
    searchApproverTwo: '',
    selectedData: [],
    selectAllData: false,
    maxSelected: dataMaxSelectedChangePic,
    valid: false,
    selectedPIC: '',
    selectedApproverOne: '',
    selectedApproverTwo: '',
    delayHitService: null,
    searchFields
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.changePIC.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.changePIC.flashError;
      },
      set() {
        this.$store.commit('changePIC/setFlashErrorMessage', '');
      },
    },
    loading() {
      return this.$store.state.changePIC.loadingDataPic;
    },
    merchants() {
      return this.$store.state.changePIC.allMerchants;
    },
    totalPage() {
      return this.$store.state.changePIC.totalPage;
    },
    totalMerchants() {
      return this.$store.state.changePIC.totalMerchants;
    },
    switchStatus() {
      return this.$store.state.changePIC.switchStatus;
    },
    percentage() {
      return this.$store.state.changePIC.percentage;
    },
    itemsInputer() {
      return this.$store.state.changePIC.allInputerData;
    },
    itemsApproverOne() {
      return this.$store.state.changePIC.allApprover1Data;
    },
    itemsApproverTwo() {
      return this.$store.state.changePIC.allApprover2Data;
    },
    loadingApproverOne() {
      return this.$store.state.changePIC.loadingApprover1;
    },
    loadingInputer() {
      return this.$store.state.changePIC.loadingInputer;
    },
    loadingApproverTwo() {
      return this.$store.state.changePIC.loadingApprover2;
    },
    showProgressBar() {
      return this.$store.state.changePIC.showProgressBar;
    },
    progressTitle() {
      return this.$store.state.changePIC.progressTitle;
    },
    progressColor() {
      return this.$store.state.changePIC.progressColor;
    },
  },

  watch: {
    showProgressBar(newStatus) {
      if (newStatus) {
        window.addEventListener("beforeunload", this.preventNavigation);
        window.addEventListener("popstate", this.preventBackNavigation);
      } else {
        window.removeEventListener("beforeunload", this.preventNavigation);
        window.removeEventListener("popstate", this.preventBackNavigation);
      }
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    searchActiveUser: {
      handler() {
        clearTimeout(this.delayHitService);
        this.delayHitService = setTimeout(() => {
          this.getActiveUser();
        }, dataDelayServiceHit);
      },
    },

    searchApproverOne: {
      handler() {
        clearTimeout(this.delayHitService);
        this.delayHitService = setTimeout(() => {
          this.getApproverOne();
        }, dataDelayServiceHit);
      },
    },
 
    searchApproverTwo: {
      handler() {
        clearTimeout(this.delayHitService);
        this.delayHitService = setTimeout(() => {
          this.getApproverTwo();
        }, dataDelayServiceHit);
      },
    },

    searchPIC: {
      handler() {
        this.getUserPIC();
      },
    },

    searchModalApproverOne: {
      handler() {
        this.getModalApproverOne();
      },
    },

    searchModalApproverTwo: {
      handler() {
        this.getModalApproverTwo();
      },
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },
    selectedData: {
      handler() {
        if (this.selectedData?.length > this.maxSelected) {
          showAlert(
            this.$store,
            `Limit selected data is ${this.maxSelected} !`,
            'mdi-alert',
            'red'
          );
          this.selectedData.splice(
            this.maxSelected,
            this.selectedData.length - 1
          );
        }
        this.checkAllSelected();
      },
    },
  },
  beforeDestroy() {
    this.clearSearch();
  },
  mounted() {
    this.getActiveUser();
    this.getApproverOne();
    this.getApproverTwo();
  },
  methods: {
    searchFilter(){
      this.options.page = 1;
      this.getData();
    },
    preventNavigation(event) {
      event.preventDefault();
      // eslint-disable-next-line no-param-reassign
      event.returnValue = "Upload masih berlangsung. Apakah Anda yakin ingin meninggalkan halaman ini?";
    },
    preventBackNavigation(event) {
      window.history.pushState(null, "", window.location.href);
      this.preventNavigation(event);    },
    beforeUnmount() {
      window.removeEventListener("beforeunload", this.preventNavigation);
    },
    resetFields() {
      this.dialogPIC = false;
      this.dialogSwitch = false;
      this.selectedPIC = '';
      this.selectedApproverOne = '';
      this.selectedApproverTwo = '';
    },
    handleClear(field) {
      this.search[field] = ''; 
      this.getData();
    },
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.merchant_name = '';
      this.search.mid = '';
      this.search.nmid = '';
      this.search.mpan = '';
      this.search.address = '';
      this.search.postal_code = '';
      this.search.request_by = '';
      this.search.approver_1 = '';
      this.search.approver_2 = '';
      this.$nextTick(() => {
        this.getData();
      });
    },

    openSwitchModal() {
      if (this.selectedData.length < 1) {
        this.dialogPIC = false;
        showAlert(this.$store, 'Data must be selected!', 'mdi-alert', 'red');
      } else {
        this.getUserPIC();
        this.dialogPIC = true;
      }
    },

    selectAll(status) {
      this.$nextTick(() => {
        const allIds = this.merchants?.map((val) => val.id);
        const filtered = allIds.filter(
          (val) => !this.selectedData.includes(val)
        );
        if (status) {
          this.selectedData = this.selectedData.concat(filtered);
        } else {
          this.selectedData = this.selectedData.filter(
            (val) => !allIds.includes(val)
          );
        }
      });
    },

    clearSelected() {
      this.searchPIC = '';
      this.searchApproverOne = '';
      this.searchApproverTwo = '';
      this.selectedPIC = '';
      this.selectedApproverOne = '';
      this.selectedApproverTwo = '';
      this.selectedData = [];
      this.selectAllData = false;
    },
    
    switchPIC() {
      this.dialogSwitch = false;
      const bulkData = [];
    
      this.selectedData.forEach(id => {
        const approvers = [
          { switch_type: "approver_1", pic_id: this.selectedApproverOne },
          { switch_type: "approver_2", pic_id: this.selectedApproverTwo },
          { switch_type: "inputer", pic_id: this.selectedPIC }
        ];
    
        approvers.forEach(({ switch_type: switchType, pic_id: picId }) => {
          if (picId) {
            bulkData.push({ id, switch_type: switchType, pic_id: picId });
          }
        });
      });
    
      if (bulkData.length > 0) {
        this.$store.dispatch('changePIC/bulkSwitch', {
          date,
          data: bulkData,
          options: this.options,
          search: this.search,
        });
      }
    
      this.selectedPIC = '';
      this.selectedApproverOne = '';
      this.selectedApproverTwo = '';
    },
    getData() {
      this.$store.commit('changePIC/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('changePIC/fetchMerchants', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage < page) {
              if (this.totalPage === 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          }
        })
        .finally(() => {
          this.checkAllSelected();
        });
    },

    checkAllSelected() {
      const allIds = this.merchants?.map((val) => val.id);
      const allSelected = allIds.filter(
        (val) => !this.selectedData.includes(val)
      );
      if (
        allSelected.length === 0 &&
        this.selectedData.length > 0 &&
        this.merchants.length > 0
      ) {
        this.selectAllData = true;
      } else {
        this.selectAllData = false;
      }
    },

    fetchUserData(action, searchKey, role) {
      this.$store.dispatch(`changePIC/${action}`, {
        date,
        userID: this[searchKey],
        role,
      });
    },

    getActiveUser() {
      this.fetchUserData('getInputerData', 'searchActiveUser', 'SALES ADMIN');
    },

    getUserPIC() {
      this.fetchUserData('getInputerData', 'searchPIC', 'SALES ADMIN');
    },

    getModalApproverOne() {
      this.fetchUserData('getApprover1Data', 'searchModalApproverOne', 'APPROVER 1');
    },

    getModalApproverTwo() {
      this.fetchUserData('getApprover2Data', 'searchModalApproverTwo', 'APPROVER 2');
    },

    getApproverOne() {
      this.fetchUserData('getApprover1Data', 'searchApproverOne', 'APPROVER 1');
    },

    getApproverTwo() {
      this.fetchUserData('getApprover2Data', 'searchApproverTwo', 'APPROVER 2');
    },

    closeFlash() {
      this.$store.commit('changePIC/setFlashErrorMessage', '');
    },

    toStep2() {
      this.$refs.form.validate();
      this.$nextTick(() => {
        if (this.valid) {
          this.dialogPIC = false;
          this.dialogSwitch = true;
        }
      });
    },
    
    toStep1() {
      this.dialogPIC = true;
      this.dialogSwitch = false;
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
};